var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'zoom-image__image-wrapper': true,
    'zoom-image__event-blocker': _vm.isPointerEventBlocked
  },on:{"click":_vm.togglePointerEventBlock}},[_c('zoom-on-hover',{ref:"zoomElement",attrs:{"img-normal":_vm.imgNormal,"img-zoom":_vm.imgZoom || _vm.imgNormal,"scale":_vm.scale,"disabled":_vm.disabled},on:{"loaded":_vm.emitImageLoaded,"resized":_vm.emitImageResized}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }